import React from 'react'
import { Divider as DividerBase, Grid as BaseGrid, TableContainer as BaseTableContainer, styled } from '@mui/material'
import {
  ArrowForward as ArrowForwardIcon,
  Info as InfoIcon,
  KeyboardArrowRight as KeyboardArrowRightIcon,
  NearMe as NearMeIcon,
  Search as SearchIcon
} from '@mui/icons-material'

export const ArrowButton = styled(KeyboardArrowRightIcon)`
  color: ${props => props.theme.palette.blue[50]};
  font-size: ${props => props.fontSize};
  margin: ${props => props.margin};
  padding: ${props => props.padding};
`

export const AttachmentsContaner = styled('div')`
  margin: 8px 0 32px 0;
  width: 100%;

  > div > .MuiGrid-container {
    margin: 0;

    > .MuiGrid-item > div {
      padding: 0;

      > .MuiGrid-container {
        padding: 0;

        > .MuiGrid-item .MuiPaper-root {
          &:first-of-type {
            padding: 0;

            > div {
              padding: 0;

              > .MuiButtonBase-root {
                margin: 0;
              }
            }
          }

          &:last-of-type {
            padding: 24px;

            > div {
              align-items: center;
              display: flex;
              flex-direction: column;
              gap: 24px;
              justify-content: center;
              padding: 0;

              > div {
                padding: 0;
              }
            }
          }
        }
      }
    }
  }
`

export const CautionInfo = styled(InfoIcon)`
  color: ${props => props.theme.palette.yellow[50]};
  font-size: ${props => props.fontSize};
  height: 18px;
  margin: ${props => props.margin};
  width: 18px;
`

export const CircleCompasArrow = styled(NearMeIcon)`
  background-color: ${props => props.theme.palette.blue[95]};
  border-radius: 50%;
  color: ${props => props.theme.palette.blue[50]};
  font-size: 18px;
  padding: 10px;
`

export const CircleWarningIcon = styled('img')`
  background-color: ${props => props.theme.palette.blue[95]};
  border-radius: 50%;
  color: ${props => props.theme.palette.blue[50]};
  font-size: 18px;
  padding: 10px;
`

export const Divider = styled(({ ...props }) => <DividerBase {...props} />)`
  margin: ${props => props.margin};
  width: 100%;
`

export const Grid = styled(({ ...props }) => <BaseGrid {...props} />)`
  margin: ${props => props.margin};
  padding: ${props => props.padding};
  text-align: ${props => props.textAlign};
  width: 100%;
`

export const GridContainer = styled(({ textAlign, ...props }) => <BaseGrid container {...props} />)`
  &.MuiGrid-container {
    height: ${props => props.height};
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`

export const IconArrowForward = styled(ArrowForwardIcon)`
  color: ${props => props.theme.palette.black};
  display: inline-block;
  font-size: ${props => props.fontSize};
  margin: ${props => props.margin};
`

export const Info = styled(InfoIcon)`
  color: ${props => props.theme.palette.blue[50]};
  font-size: ${props => props.fontSize};
  height: 16px;
  margin: ${props => props.margin};
  width: 16px;
`

export const Link = styled('a')`
  color: ${props => props.theme.palette.blue[50]};
  cursor: pointer;
  display: block;
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: ${props => props.fontSize || '14px'};
  font-style: normal;
  font-weight: ${props => props.fontWeight || 400};
  margin: ${props => props.margin};
  text-align: ${props => props.textAlign};
  text-decoration-line: underline;
`

export const LinkButton = styled('button')`
  background: none;
  border: none;
  color: ${props => props.theme.palette.blue[50]};
  cursor: pointer;
  display: block;
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: ${props => props.fontSize || '14px'};
  font-style: normal;
  font-weight: ${props => props.fontWeight || 400};
  margin: ${props => props.margin || '0'};
  padding: 0;
  text-align: ${props => props.textAlign || 'left'};
  text-decoration-line: underline;

  &:hover {
    color: ${props => props.theme.palette.blue[70]};
  }

  &:focus {
    outline: 2px solid ${props => props.theme.palette.blue[30]};
    outline-offset: 2px;
  }
`

export const Root = styled('div')`
  width: 100%;
`

export const RowRadio = styled('div')`
  margin-top: 8px;
  text-align: left;
  width: 100%;
`

export const SearchIconCustom = styled(SearchIcon)`
  height: 20px;
  width: 20px;
`

export const SearchSuffix = styled('span')`
  background-color: ${props => props.theme.palette.blue[50]};
  border-right: 1px solid ${props => props.theme.palette.blue[50]};
  color: ${props => props.theme.palette.brand.white};
  padding: 10px;
`

export const Strong = styled('strong')`
  font-size: 14px;
`

export const TableContainer = styled(BaseTableContainer)`
  &.MuiTableContainer-root {
    margin-bottom: 20px;
  }
`

export const DivColumn = styled(Grid)(({ theme }) => ({
  padding: '16px 0 16px 0'
}))
